import teamService from '@/api/team'
import { TEAM } from '../types'
import errorhandler from '@/utils/errorhandler.js'

export default{
  namespaced: true,
  state: {
    teams: [],
  },
  getters: {
    teams: (state) => {
      return state.teams
    }
  },
  mutations: {
    [TEAM.SET_TEAMS](state, value){
      state.teams = value
    }
  },
  actions: {
    getMyTeams({commit, dispatch}) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve) => {
        teamService.getMyTeams().then((response) =>{
          commit(TEAM.SET_TEAMS, response.data)
          resolve()
        }).catch((error) => {
          errorhandler.handleError(error)
        }).finally(() =>{
          dispatch('Global/hideLoading', null, { root: true })
        })
      })
    },
    async searchEmployees(_, obj) {
      try {
        let response = await teamService.searchEmployees(obj)
        let employees = response.data

        return employees
      } catch (error) {
        errorhandler.handleError(error)
      }
    },
  }
}
